import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  CircularProgress,
  TextField,
  Button,
} from "@mui/material";
import axios from "axios";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";

function MonthlyPayrollSummary() {
  const [payrolls, setPayrolls] = useState([]);
  const [loading, setLoading] = useState(true);
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");

  useEffect(() => {
    fetchSummary();
  }, []);

  const fetchSummary = async () => {
    try {
      const res = await axios.get("/api/payrolls/", {
        headers: { Authorization: `Bearer ${localStorage.getItem("access")}` },
      });
      setPayrolls(res.data);
    } catch (err) {
      console.error("Failed to fetch payrolls", err);
    } finally {
      setLoading(false);
    }
  };

  const filtered = payrolls.filter((p) => {
    return (
      (month ? p.month === month : true) &&
      (year ? String(p.year) === year : true)
    );
  });

  const chartData = Object.values(
    filtered.reduce((acc, item) => {
      const key = item.teacher?.full_name || item.support_staff_name;
      acc[key] = acc[key] || { name: key, total: 0 };
      acc[key].total += parseFloat(item.total_paid);
      return acc;
    }, {})
  );

  return (
    <Box p={3}>
      <Typography variant="h5" mb={2}>
        Monthly Payroll Summary
      </Typography>

      <Box display="flex" gap={2} mb={2}>
        <TextField
          label="Filter by Month"
          value={month}
          onChange={(e) => setMonth(e.target.value)}
        />
        <TextField
          label="Filter by Year"
          value={year}
          onChange={(e) => setYear(e.target.value)}
        />
        <Button variant="contained" onClick={fetchSummary}>
          Refresh
        </Button>
      </Box>

      {loading ? (
        <CircularProgress />
      ) : (
        <>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Staff Name</TableCell>
                  <TableCell>Month</TableCell>
                  <TableCell>Year</TableCell>
                  <TableCell>Total Paid</TableCell>
                  <TableCell>Paid Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filtered.map((item) => (
                  <TableRow key={item.id}>
                    <TableCell>{item.teacher?.full_name || item.support_staff_name}</TableCell>
                    <TableCell>{item.month}</TableCell>
                    <TableCell>{item.year}</TableCell>
                    <TableCell>${item.total_paid}</TableCell>
                    <TableCell>{item.is_paid ? "✅" : "❌"}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          <Box mt={4} height={300}>
            <Typography variant="h6" mb={1}>
              Total Paid Per Staff
            </Typography>
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={chartData}>
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Bar dataKey="total" fill="#4caf50" />
              </BarChart>
            </ResponsiveContainer>
          </Box>
        </>
      )}
    </Box>
  );
}

export default MonthlyPayrollSummary;
